import { ExternalLink } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { publicQuotesUrl } from '@/models/publicQuotes'
import { FillApplicationEvent, trackFillApplication } from './fillApplicationAnalytics'
import { LinkField } from './LinkField'

interface ViewOnlyLinkProps {
  orgId: string
  applicationId: string | null
  /** Sent to carriers, so there are quotes to look at. */
  available: boolean
}

export function ViewOnlyLink({ orgId, applicationId, available }: ViewOnlyLinkProps) {
  const url = applicationId ? publicQuotesUrl(applicationId) : null

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-ink text-sm font-semibold">View-only link</h3>
      <p className="text-ink-500 text-sm">
        Anyone with it sees the prices without signing in. It doesn&apos;t show their fleet, drivers or
        documents, and nobody can buy from it.
      </p>
      {available && url ? (
        <LinkField
          url={url}
          label="View-only link"
          onCopied={() => trackFillApplication(FillApplicationEvent.VIEW_ONLY_LINK_COPIED, { org_id: orgId })}
        >
          <Button variant="outline" href={url} target="_blank">
            <ExternalLink /> Open
          </Button>
        </LinkField>
      ) : (
        <span className="text-ink-500 text-xs">Send the application to carriers first.</span>
      )}
    </div>
  )
}
